import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, denim} from '/theme/color/on.color';
import {graniteGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    paddingTop: indent / 2 + 2,
    width: '100%' as const,
    minHeight: 48,
    outlineWidth: 0,
  },
  icon: {
    marginRight: indent,
    paddingVertical: 0,
    paddingBottom: 0,
    width: 24,
    alignSelf: 'center' as const,
    display: 'flex' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
  },
  textContainer: {
    paddingBottom: indent / 2 + 2,
    paddingVertical: 0,
    flexDirection: 'row' as const,
    flex: 1,
    justifyContent: 'space-between' as const,
    alignItems: 'center' as const,
    minHeight: 24,
  },
  nonTerminal: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  statusText: {
    marginTop: 4,
    textAlign: 'left' as const,
    color: denim,
    fontWeight: '600' as const,
    fontSize: 12,
    lineHeight: 17,
  },
  arrowIcon: {
    color: graniteGray,
    fontSize: 18,
    alignSelf: 'center' as const,
  },
});
